import React from 'react';

const ChartSkeletonLoader = () => {
  const skeletonStyles = `
    @keyframes shimmer {
      0% {
        background-position: -1000px 0;
      }
      100% {
        background-position: 1000px 0;
      }
    }

    .skeleton-card {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 16px;
      box-sizing: border-box;
      position: relative;
      border-radius: 12px;
      overflow: hidden;
      background-color: #f4f4f4;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }

    .skeleton-card::after {
      content: '';
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-image: linear-gradient(
        90deg,
        rgba(255,255,255,0) 0%,
        rgba(255,255,255,0.6) 50%,
        rgba(255,255,255,0) 100%
      );
      animation: shimmer 1.5s infinite ease-in-out;
      background-size: 1000px 100%;
      z-index: 1;
    }

    .skeleton-header,
    .skeleton-row,
    .skeleton-bar,
    .skeleton-circle,
    .skeleton-donut,
    .skeleton-table-row {
      background-color: #e0e0e0;
      position: relative;
      z-index: 2;
    }

    .skeleton-header {
      width: 50%;
      height: 24px;
      border-radius: 8px;
      margin-bottom: 20px;
    }

    .skeleton-row {
      width: 100%;
      height: 14px;
      border-radius: 6px;
    }

    .skeleton-row:nth-child(even) {
      width: 80%;
    }

    .skeleton-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .skeleton-bars {
      display: flex;
      height: 60%;
      justify-content: space-between;
      align-items: flex-end;
      margin-top: auto;
      margin-bottom: 12px;
      gap: 4px;
    }

    .skeleton-bar {
      width: 8%;
      border-radius: 6px 6px 0 0;
    }

    .skeleton-circles {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin-top: auto;
    }

    .skeleton-circle {
      border-radius: 50%;
      background-color: #e0e0e0;
    }

    .skeleton-table-rows {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .skeleton-table-row {
      width: 100%;
      height: 20px;
      border-radius: 6px;
    }

    .skeleton-table-row:nth-child(odd) {
      height: 28px;
    }

    .skeleton-donut {
      width: 160px;
      height: 160px;
      border-radius: 50%;
      border: 24px solid #e0e0e0;
      margin: auto;
    }
  `;

  return (
    <>
      <style>{skeletonStyles}</style>
      <div className="charts">
        <div className="charts__left">
          {/* Bar chart */}
          <div className="charts__left_child">
            <div className="skeleton-card">
              <div className="skeleton-header" />
              <div className="skeleton-bars">
                {[...Array(10)].map((_, i) => (
                  <div
                    key={i}
                    className="skeleton-bar"
                    style={{ height: `${30 + Math.random() * 60}%` }}
                  />
                ))}
              </div>
              <div className="skeleton-row" />
            </div>
          </div>

          {/* Word cloud */}
          <div className="charts__left_child">
            <div className="skeleton-card">
              <div className="skeleton-header" />
              <div className="skeleton-content">
                {[...Array(6)].map((_, i) => (
                  <div
                    key={i}
                    className="skeleton-row"
                    style={{
                      width: `${50 + Math.random() * 50}%`,
                      marginLeft: `${Math.random() * 20}%`,
                    }}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Bubble chart */}
          <div className="charts__left_child_bubble">
            <div className="skeleton-card">
              <div className="skeleton-header" />
              <div className="skeleton-circles">
                {[...Array(12)].map((_, i) => {
                  const size = 20 + Math.random() * 40;
                  return (
                    <div
                      key={i}
                      className="skeleton-circle"
                      style={{
                        width: `${size}px`,
                        height: `${size}px`,
                      }}
                    />
                  );
                })}
              </div>
            </div>
          </div>

          {/* Donut chart */}
          <div className="charts__left_child">
            <div className="skeleton-card">
              <div className="skeleton-header" />
              <div
                className="skeleton-content"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div className="skeleton-donut" />
              </div>
            </div>
          </div>

          {/* Line chart */}
          <div
            className="charts__left_child_big"
            style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
          >
            <div className="skeleton-card">
              <div className="skeleton-header" />
              <div className="skeleton-content">
                {[...Array(4)].map((_, i) => (
                  <div
                    key={i}
                    className="skeleton-row"
                    style={{
                      width: '100%',
                      height: '20px',
                      marginTop: i === 0 ? 'auto' : '0',
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="charts__right">
          {/* Table */}
          <div className="charts__right__table">
            <div className="skeleton-card">
              <div className="skeleton-header" />
              <div className="skeleton-table-rows">
                {[...Array(12)].map((_, i) => (
                  <div key={i} className="skeleton-table-row" />
                ))}
              </div>
            </div>
          </div>

          {/* Cylinder chart */}
          <div className="charts_right_child">
            <div className="skeleton-card">
              <div className="skeleton-header" />
              <div className="skeleton-bars">
                {[...Array(8)].map((_, i) => (
                  <div
                    key={i}
                    className="skeleton-bar"
                    style={{
                      height: `${40 + Math.random() * 50}%`,
                      width: '10%',
                      borderRadius: '6px 6px 0 0',
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChartSkeletonLoader;
